import React from 'react';

export const ContactAddress = () => {
  return (
    <svg width="9" height="13" viewBox="0 0 9 13" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3.9375 12.2188C2.71875 10.6953 0 7.0625 0 5C0 2.51562 1.99219 0.5 4.5 0.5C6.98438 0.5 9 2.51562 9 5C9 7.0625 6.25781 10.6953 5.03906 12.2188C4.75781 12.5703 4.21875 12.5703 3.9375 12.2188ZM4.5 6.5C5.32031 6.5 6 5.84375 6 5C6 4.17969 5.32031 3.5 4.5 3.5C3.65625 3.5 3 4.17969 3 5C3 5.84375 3.65625 6.5 4.5 6.5Z"
        fill="#FFBF17"
      />
    </svg>
  );
};
